import React, { useState, useEffect, useContext} from 'react';
import MUIDataTable from 'mui-datatables';
import { Link as RouterLink } from 'react-router-dom';

// material
import {
    Card,
    Stack,
    Alert,
    Button,
    Container,
    Typography,
    MenuItem,  
    ListItemIcon, 
    ListItemText,
    AlertTitle
  } from '@mui/material';

import { ThemeProvider } from '@mui/material/styles';
import Theme from '../../components/Button';

import {api, reiniciarToken, consultaClientes, excluirClientes} from '../../services/api';
// context
import { AuthContext } from '../../contexts/auth';

import Page from '../../components/Page';
import Iconify from '../../components/Iconify';

export default function ConsultaCliente() {

  const { logout } = useContext(AuthContext);
  const [dados, setData] = useState([]);

  const getClientes = async () => {
    
    const retorno = await reiniciarToken();
    if(retorno.erro === true) {
      if (retorno.mensagem === 'O Token é inválido!' || retorno.mensagem === 'Acesso negado!'){
        logout();
      }
    }else{
      localStorage.setItem("token", retorno.data.token);
      api.defaults.headers.Authorization = `Bearer ${retorno.data.token}`;
    }

    const response = await consultaClientes();
    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }
    }else { 
      // setData(response.data);

      response.data.forEach((valores) => {
        setData(dados => [...dados, {id_cliente: valores.id_cliente
                                    ,cnpj_cpf: valores.cnpj_cpf
                                    ,nome: valores.nome
                                    ,tipo_pessoa: (valores.tipo_pessoa === '1') ? 'Física' : 'Jurídica'
                                    ,email: valores.email
                                    ,contato: valores.contato
                                    ,telefone_celular: valores.telefone_celular}]);
      });
    }; 
  }

  useEffect(() => {
    getClientes();
  },[]) 

  const [status, setStatus] = useState({
    type: '',
    mensagem: ''
  }) 
  
  
  const excluirCliente = async (id) => {
    const response = await excluirClientes(id);

    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }else {
        setStatus({
          type: "erro",
          mensagem: response.mensagem
        })
      }
    }else {
      setStatus({
        type: "success",
        mensagem: response.data.mensagem
      })
      setData([]);
      getClientes();
    }; 
  }
  
  const columns = [{name: "Ação",
                    options: {
                      filter: false,
                      sort: false,
                      empty: true,
                      customBodyRenderLite: (dataIndex, rowIndex) =>  {
                        return (
                          <> 
                            <MenuItem onClick={() => excluirCliente(dados[dataIndex].id_cliente)} sx={{ color: 'text.secondary' }}>
                              <ListItemIcon>
                                  <Iconify icon="eva:trash-2-outline" width={24} height={24} />
                              </ListItemIcon>
                              <ListItemText primary="Excluir" primaryTypographyProps={{ variant: 'body2' }} />
                            </MenuItem>

                            <MenuItem component={RouterLink} to={`/cliente/editar/${dados[dataIndex].id_cliente}`} sx={{ color: 'text.secondary' }}>
                              <ListItemIcon>
                                  <Iconify icon="eva:edit-fill" width={24} height={24} />
                              </ListItemIcon>
                              <ListItemText primary="Alterar" primaryTypographyProps={{ variant: 'body2' }} />
                            </MenuItem>
                          </> 
                        );
                      }
                    }
                  }
                  ,{name:"id_cliente", label: "Código"} 
                  ,{name:"cnpj_cpf", label: "CPF/CNPJ"}
                  ,{name:"nome", label: "Nome"}
                  ,{name:"tipo_pessoa", label: "Tipo Pessoa"}
                  ,{name:"email", label: "E-mail"}
                  ,{name:"contato", label: "Contato"}
                  ,{name:"telefone_celular", label: "Celular"}
                  ];

  const options = {
    filterType: "dropdown",
    tableBodyHeight: "100%",
    selectableRows: "none",
    responsive: "standard",
  };             
                    
  return (
    <Page title="Cliente">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Consulta de Clientes
          </Typography>
          <ThemeProvider theme={Theme}>
            <Button variant="contained" color="neutral" component={RouterLink} to="/cliente/cadastrar" startIcon={<Iconify icon="eva:plus-fill" />}>
              Novo Cliente
            </Button>
          </ThemeProvider>
        </Stack>
        <Card>
            <Stack spacing={3}>
              {status.type === 'erro' ? <Alert severity="error"><AlertTitle>Erro</AlertTitle>{status.mensagem}</Alert> : ""}
              {status.type === 'success' ? <Alert severity="success"><AlertTitle>Sucesso</AlertTitle>{status.mensagem}</Alert> : ""}
            </Stack > 
            <MUIDataTable
                data={Object.values(dados)}
                columns={columns}  
                options={options} 
            />
        </Card>
      </Container>  
    </Page>  
  );
}

